
import { useEffect, useState } from "react"
import { ChartstwitsRepository } from "../../repository/ChartstwitsRepository";
import { useSearchParams } from 'react-router-dom';
export function TickerModel(){
    const apiModel = ChartstwitsRepository();
    const [searchParams] = useSearchParams();
    const ticker = searchParams.get('ticker');
    const [tickerdata,setTickerData] = useState() as any;
    const imagePath = apiModel.chartTwitsImagePath;
    const chartTwitsApi = apiModel.chartTwitsApi;

    const [lstPosts,setPosts] = useState([]);
    
    const [comment,setComment] = useState({
        ChartTwit_ID : 0,
        UserId : 0,
        ChartComment : '',
        Type : '',
    })


    const ViewData = async () =>{
        debugger;
       
        debugger;
        const data = await fetch('https://demo-live-data.highcharts.com/aapl-ohlcv.json').then(response => response.json());

        const responseData:any = await apiModel.getHistoricalData(ticker);

        const formattedData = responseData.data.tradesTable.rows.map((data:any) => [
            new Date(data.date).getTime(),  // x value (timestamp)
            parseFloat(data.open.substring(1)),  // open
            parseFloat(data.high.substring(1)),  // high
            parseFloat(data.low.substring(1)),   // low
            parseFloat(data.close.substring(1))  // close
        ]);
        
        debugger;
        const options = {
            chart: {
                type: 'candlestick',
                zoomType: 'x'
              },
              title: {
                text: 'Hollow Candlestick Chart'
              },
              rangeSelector: {
                selected: 1,
                buttons: [{
                    type: 'month',
                    count: 1,
                    text: '1m'
                }, {
                    type: 'month',
                    count: 3,
                    text: '3m'
                }, {
                    type: 'month',
                    count: 6,
                    text: '6m'
                }, {
                    type: 'ytd',
                    text: 'YTD'
                }, {
                    type: 'year',
                    count: 1,
                    text: '1y'
                }, {
                    type: 'all',
                    text: 'All'
                }]
            },
            navigator: {
                enabled: true
            },
            plotOptions: {
                candlestick: {
                    color: 'red', // Color for down candles
                    upColor: 'green' // Color for up candles
                }
            },
              series: [{
                type: 'candlestick',
                name: ticker,
                data: formattedData
                // data: data
              }]
          }
          setTickerData(options)
    }
    
    const reactionClick = async (d:any,e:any) =>{
        debugger;
        saveChartReactions(d,e);
    }

    const saveChartReactions = async (d:any,e:any) =>{
        debugger;
        const responseData: any = await apiModel.saveChatReactions(d,e);
        // getdata(dataDate.startDate,dataDate.endDate)
        debugger;
    }

    const addComment = async (d:any) =>{
        debugger;
        let newPost = {...comment};
        newPost.ChartTwit_ID = d.Post_ID;
        newPost.Type = d.Type;
        setComment(newPost);
    }
   

    useEffect(()=>{
        ViewData();

        if(ticker !=''){
            debugger;
            viewTwits();
        }   


    },[])


    const viewTwits = async () =>{
        debugger;
        const responseData: any = await apiModel.viewTwits();
        debugger;
        const data = responseData.filter((x: any) => x.Ticker === ticker && x.Blocked === 0 && x.User_Blocked === 0);
        debugger;
        if(data.length > 0){
            setPosts(data)
        }
        
    }

    return{tickerdata,lstPosts , imagePath,reactionClick,addComment}
}